
<button
  *ngIf="store.canSeeOrders(); else orderName"
  mat-button
  class="cell-link"
  (click)="goToOrder($event)">
  {{ cellValue.order.name }}
</button>
<ng-template #orderName>{{ cellValue.order.name }}</ng-template>